import HTTP from '../lib/http';
// const { isProd } = require('../lib/env');

const CONTENT_BASE = "https://bieyangapp.com/"
const API_BASE = "https://baleen-prod.bybieyang.com/"
const API_BASE2 = "https://baleen2-prod.bieyangapp.com/"
const FIFTHAPI = "https://5thave-prod.bieyangapp.com/"
/**
 * 获取文章资源 url , image / video / json, etc
*/
function getResource(path = "") {
    if (!path) {
      return "";
    }
    let _path = path
    if (path.indexOf('bxl.ipinyou.com') !== -1) {
        if (path.indexOf('/pt') !== -1 || path.indexOf('/pf') !== -1) {
            _path = path.replace('bxl.ipinyou.com', '5thave-img-cdn-g.bybieyang.com')
        } else {
            _path = path.replace('bxl.ipinyou.com', 'baleen-cdn-g.bybieyang.com')
        }
    }
    if (
      /^((ht|f)tps?):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/i.test(
        _path
      )
    ) {
      return _path
    }
  
    if (_path.startsWith("/")) {
      return CONTENT_BASE + "static/curation" + _path
    }
    return CONTENT_BASE + "static/curation/" + _path
}

// 获取openId
export function getOpenId(code: string) {
    return HTTP.get(`/api/v1/wechat/openId?code=${code}`);
}

// 获取新人大礼包配置
export function getNewUserCoupon() {
    return HTTP.get('/api/v1/appconfig')
}

function getReleteArtileAPI(id: string) {
    return API_BASE + "articles/" + id + "/related?f=0&t=5"
}

function getArticleRes(jsonContents = "") {
    if (!jsonContents) {
        return ""
    }
    if (jsonContents.endsWith(".json")) {
        return getResource(jsonContents)
    }
    return getResource(jsonContents) + "/contents.json?v=" + new Date().getTime()
}

export const newComerConfig = () => {
    return HTTP.get(FIFTHAPI + 'api/v1/appconfig')
}

function getArticleComments(articleInfo: any) {
    return (
        API_BASE2 +
        "v1/articles/" +
        articleInfo.articleId +
        "/comments?f=" +
        (articleInfo.pageNo * 10 - 10) +
        "&t=" +
        articleInfo.pageNo * 10 +
        "&s=" +
        articleInfo.type
    )
}

function getReplayUrl(info: any) {
    if (info.commentId) {
        return API_BASE2 + "v1/articles/" + info.articleId + "/comments/" + info.commentId + "/replies"
    }
    return API_BASE2 + "v1/articles/" + info.articleId + "/comments"
}

//点赞
function getLikeUrl(info: any) {
    return (
      API_BASE2 +
      "v1/articles/" +
      info.articleId +
      "/comments/" +
      info.commentId +
      "/likes"
    )
}

export default {
    productInfoPath: "/api/v1/products/_batch/load",
  discoverV3: FIFTHAPI + "api/v3/discover/recommendation",
  relatedArticles: "/articles/",
  getResource,
  getArticleRes,
  getReleteArtileAPI,
  getArticleComments,
  getReplayUrl,
  getLikeUrl,
  favorites: FIFTHAPI + 'api/v1/favorites',
  alreadyFavorites: FIFTHAPI + 'api/v1/favorites?prodInfo=true',
  shareUrl: FIFTHAPI + 'api/v1/shareprograms/sharing/ARING_ARTICLE',
}
  